export const studentDefaultBG='https://images.wallpaperscraft.com/image/single/books_library_shelves_138556_3840x2400.jpg'
export const ProfessionalDefaultBG='https://wallpaperaccess.com/full/8061909.jpg'
export const companiesImg=[ "https://thumbs.dreamstime.com/b/new-google-logo-vector-illustration-white-background-editorial-149046989.jpg",
"https://www.freeiconspng.com/uploads/facebook-f-logo-white-background-21.jpg",
"https://logodownload.org/wp-content/uploads/2015/05/uber-logo-3-1.png",
"https://static.vecteezy.com/system/resources/previews/017/221/833/non_2x/apple-logo-free-png.png",
"https://thumbs.dreamstime.com/b/amazon-logo-159029074.jpg",
"https://i.pinimg.com/736x/da/f3/0f/daf30fac5e16393d66a3684dd27e29af.jpg",
"https://1000logos.net/wp-content/uploads/2017/04/Microsoft-logo.jpg",]

export const instituteImg=['https://www.pngkit.com/png/detail/802-8025099_advertisement-iit-bombay-logo.png',
'https://static.toiimg.com/thumb/msid-78139990,width-400,resizemode-4/78139990.jpg',
'https://png.pngitem.com/pimgs/s/215-2156453_banaras-hindu-university-banaras-hindu-university-logo-hd.png',
'https://www.cam.ac.uk/sites/www.cam.ac.uk/files/inner-images/logo.jpg',
'https://scontent.fccu11-1.fna.fbcdn.net/v/t39.30808-6/307013441_409230498059060_7246421584392431890_n.png?_nc_cat=104&ccb=1-7&_nc_sid=09cbfe&_nc_ohc=m7kOlGmlB0cAX-RoV6N&_nc_ht=scontent.fccu11-1.fna&oh=00_AfDZEqJzlqtIfkYgcUpegRo0XhhRhCAfgQunM26CYT9YXw&oe=646A3CE6',
'https://yt3.googleusercontent.com/ytc/AGIKgqOqarQhLLIsoTy8iDPnFETYhrCQjKjprh-be0gx=s900-c-k-c0x00ffffff-no-rj'
]

export const BGimage = [
    "https://wallpaperaccess.com/full/4545909.jpg",'https://cdn.pixabay.com/photo/2017/05/11/11/15/workplace-2303851_1280.jpg',
    "https://wallpaperaccess.com/full/4545909.jpg",'https://cdn.pixabay.com/photo/2017/05/11/11/15/workplace-2303851_1280.jpg',
    "https://wallpapercave.com/wp/wp6940885.jpg",
    "https://a-static.besthdwallpaper.com/fantasy-world-wallpaper-2880x1620-29897_52.jpg",
    "https://static1.squarespace.com/static/5fe4caeadae61a2f19719512/5fe5c3a9d85eb525301180ed/5ff082ae17af6f5d1930e6bf/1610530333403/Wallpaper+engine+4k.png?format=1500w",
    "https://downloadhdwallpapers.in/wp-content/uploads/2017/12/Code-in-Laptop-Computer-1366x768.jpg",
    "https://www.pixelstalk.net/wp-content/uploads/images6/Laptop-Wallpaper-4K-High-Resolution.jpg",
    "https://www.pixel4k.com/wp-content/uploads/2018/09/minato-japan-night-city-bridge-4k_1538065305.jpg.webp",
    "https://images.squarespace-cdn.com/content/v1/5fe4caeadae61a2f19719512/1609949775007-FKI50MYWWQG9KZHEA06W/35.jpg",
  ];
export const studentPreDefinedData=[
    {
        "ListId": "5e77af99-f99e-446c-a217-ec3b4711e7c2",
        "nameOfList": "Topics 📖",
        "tasks": [
            {
                "cardItemId": "9fc904e8-2ad9-4add-8549-a5ff1a2c5356",
                "nameOfCardItem": "Binary Search Tree",
                "description": "",
                "activity": [
                    {
                        "text": "Binary Search Tree added to Topics 📖",
                        "time": ""
                    }
                ]
            }
        ]
    },
    {
        "ListId": "a0a35794-7134-4241-afc1-778d35790a54",
        "nameOfList": "Focus 🎯",
        "tasks": [
            {
                "cardItemId": "06f896c7-d9b5-4b20-8ff3-f9a48d504261",
                "nameOfCardItem": "Dynamic Programming",
                "description": "",
                "activity": [
                    {
                        "text": "Dynamic Programming added to Focus 🎯",
                        "time": ""
                    }
                ]
            }
        ]
    },
    {
        "ListId": "01c126ed-aabe-46b1-a956-3288a0669dfb",
        "nameOfList": "Current👀",
        "tasks": [
            {
                "cardItemId": "3113a80f-a609-4968-9e63-07be847e687f",
                "nameOfCardItem": "Graphs",
                "description": "",
                "activity": [
                    {
                        "text": "Graphs added to Current👀",
                        "time": ""
                    }
                ]
            }
        ]
    },
    {
        "ListId": "b11cfd9b-c828-4e18-9398-ebec57bb4ef9",
        "nameOfList": "Covered ✔️",
        "tasks": [
            {
                "cardItemId": "99c6af2f-6147-440e-b816-b540fbc0bc8e",
                "nameOfCardItem": "Heaps",
                "description": "",
                "activity": [
                    {
                        "text": "Heaps added to Covered ✔️",
                        "time": ""
                    }
                ]
            },
            {
                "cardItemId": "b8b9b4b7-917f-49ab-8f23-9a50f0ffa524",
                "nameOfCardItem": "Sorting ",
                "description": "",
                "activity": [
                    {
                        "text": "Sorting added to Covered ✔️",
                        "time": ""
                    }
                ]
            }
        ]
    }
]


export const professionalPreDefinedData=[
    {
        "ListId": "94a8040d-3d97-4e2a-ae9e-fea2f81e0882",
        "nameOfList": "PRD❓ ",
        "tasks": [
            {
                "cardItemId": "5faebde0-7579-457d-8c40-327ac9a5871d",
                "nameOfCardItem": "Define the Kanban Board layout",
                "description": "",
                "activity": [
                    {
                        "text": "Define the Kanban Board layout added to ❓",
                        "time": ""
                    }
                ]
            },
            {
                "cardItemId": "82657f98-11d1-4aed-ae63-f8760f569ea5",
                "nameOfCardItem": "Create React components",
                "description": "",
                "activity": [
                    {
                        "text": "Create React components added to PRD",
                        "time": ""
                    }
                ]
            },
            {
                "cardItemId": "754f5106-f0f3-4aa2-b252-bece3192253a",
                "nameOfCardItem": "Implement drag and drop functionality",
                "description": "",
                "activity": [
                    {
                        "text": "Implement drag and drop functionality added to PRD",
                        "time": ""
                    }
                ]
            },
            {
                "cardItemId": "6d643f0f-b511-4835-b3a3-8cf1f1b65680",
                "nameOfCardItem": "Manage the state of the application",
                "description": "",
                "activity": [
                    {
                        "text": "Manage the state of the application added to PRD",
                        "time": ""
                    }
                ]
            },
            {
                "cardItemId": "1a7cb24c-920d-4cff-b284-fa824931591a",
                "nameOfCardItem": "Add functionality for adding and editing tasks",
                "description": "",
                "activity": [
                    {
                        "text": "Add functionality for adding and editing tasks added to PRD",
                        "time": ""
                    }
                ]
            },
            {
                "cardItemId": "eb228c3d-a031-420a-a05a-5f3e1b74d654",
                "nameOfCardItem": "Implement customizations",
                "description": "",
                "activity": [
                    {
                        "text": "Implement customizations added to PRD",
                        "time": ""
                    }
                ]
            },
            {
                "cardItemId": "56e56554-88d7-46bb-906d-9ffed4fccd1c",
                "nameOfCardItem": "Test and deploy",
                "description": "",
                "activity": [
                    {
                        "text": "Test and deploy added to PRD",
                        "time": ""
                    }
                ]
            }
        ]
    },
    {
        "ListId": "7b6cf0a9-d8c0-4d08-bfeb-4068141a823f",
        "nameOfList": "In-Process📈",
        "tasks": []
    },
    {
        "ListId": "fcdcfddb-73ee-4b40-9ea5-988529679bac",
        "nameOfList": "Yet to be debugged 🪲",
        "tasks": []
    },
    {
        "ListId": "7929da86-0400-4191-bfe6-8c5cba17e335",
        "nameOfList": "Completed ✔️",
        "tasks": [
            {
                "cardItemId": "a6a1fc7a-a167-4490-8771-7a29b2d7f47f",
                "nameOfCardItem": "Set up the React development environment",
                "description": "",
                "activity": [
                    {
                        "text": "Moved from PRD to Completed",
                        "time": ""
                    },
                    {
                        "text": "Set up the React development environment added to PRD",
                        "time": ""
                    }
                ]
            }
        ]
    },
    {
        "ListId": "9e30c21f-ace0-41d8-b183-fde7f82058d7",
        "nameOfList": "Tested",
        "tasks": []
    }
]
